import React, { useContext, useEffect, useState } from "react"
import Item from "./Item"
import { Container } from "./HeaderStyled"
import { cubesData } from "./cubesData"
import { getActivated, getNumber } from "./helpers"
import { AppContext } from "../../../context/createContext"

export default function JackpotHeader({
  tempRemoveComponents,
  jackpotPopup,
  isJackpot,
}: any) {
  const { jackpot, jackpotInfo } = useContext(AppContext)
  const [jackpotWinner, setJackpotWinner] = useState<any>(jackpotInfo)
  const [jackpotData, setJackpotData] = useState<any>()

  const empty = {
    wintype: 0,
  }

  const [joinedData, setjoinedData] = useState(
    getNumber(cubesData, jackpot.progress_bars)
  )

  useEffect(() => {
    setJackpotData(jackpotInfo.items)
  }, [jackpotInfo])

  const win =
    jackpotWinner.wintype === 1
      ? "solar"
      : jackpotWinner.wintype === 2
      ? "galactical"
      : jackpotWinner.wintype === 3
      ? "stellar"
      : ""

  useEffect(() => {
    let timeout: any = null
    // jackpotInfo[0].currency && sethasJackpot(true)
    // setjoinedData(getNumber(joinedData, jackpotInfo))
    jackpotInfo.wintype !== 0 && setJackpotWinner(jackpotInfo)
    timeout = setTimeout(() => {
      setJackpotWinner(empty)
    }, 3000)

    return () => clearTimeout(timeout)
  }, [jackpotInfo])

  useEffect(() => {
    let timeout: any = null
    jackpot.wintype !== 0 && isJackpot && setJackpotWinner(jackpot)
    timeout = setTimeout(() => {
      setJackpotWinner(empty)
    }, 3000)

    return () => clearTimeout(timeout)
  }, [jackpot, isJackpot])

  useEffect(() => {
    setjoinedData(getActivated(joinedData, jackpot.progress_bars))
  }, [jackpot.progress_bars])

  return (
    <>
      {jackpotData && jackpotData.length && (
        <Container tempRemoveComponents={tempRemoveComponents}>
          {jackpotData.map((cube: any, index: any) => (
            <Item
              key={index}
              text={cubesData[index].text}
              number={jackpotData[index].values}
              background={cubesData[index].background}
              color={cubesData[index].color}
              dotBackground={cubesData[index].dotBackground}
              dotInactiveBackground={cubesData[index].dotInactiveBackground}
              dotShadow={cubesData[index].dotShadow}
              activated={joinedData[index].activated}
              hasDot={jackpotPopup}
              numberColor={cubesData[index].numberColor}
              currency={jackpotData[index].currency}
              winner={win === cubesData[index].text}
            >
              <img src={cubesData[index].svg} alt="" />
            </Item>
          ))}
        </Container>
      )}
    </>
  )
}
